import baseURL from "../Api/baseURL";
const loggedUser=JSON.parse(localStorage.getItem('user')); 
const token = loggedUser?.token

export const useUpdateData=async(url,params)=>{
     const updateConfig={
        headers: {
 ...(token
      ? { Authorization: `Bearer ${token}` }
      : { is_admin: true }),          }
    };

    const res=await baseURL.put(url,params,updateConfig);
    return res.data;
};



export const useUpdateDataWithImage=async(url,params)=>{
    const updateConfig={
        headers: {
            "Content-Type": "multipart/form-data",
 ...(token
      ? { Authorization: `Bearer ${token}` }
      : { is_admin: true }),          }
    };
    const res=baseURL.put(url,params,updateConfig);
    return res;
}